<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import NestedCheckbox from './_NestedCheckbox.vue'
import PriceRangeSlider from './_PriceRangeSlider.vue'
import { usePCSFilter } from '@/lib/usePCSFilter'

const { t } = useI18n()

const {
	rawFilterData,
	brandList,
	checkboxTitles,
	locationList,
	colorList,
	osList,
	AttributeID,
	storageList,
	seriesList,
	manufactList,
} = usePCSFilter()
</script>

<template>
	<div
		v-if="rawFilterData"
		class="flex w-full flex-col gap-y-24px text-n-950 lg:min-w-[286px] lg:max-w-[286px]"
	>
		<NestedCheckbox
			:items="brandList"
			:checkboxTitle="t('pcs_filter_brand')"
			isOpenedInitially
		></NestedCheckbox>

		<PriceRangeSlider
			:checkboxTitle="t('pcs_filter_price')"
			isOpenedInitially
		/>

		<div class="typography-h5-str">{{ t('pcs_filter_source') }}</div>
		<template v-for="location in locationList">
			<NestedCheckbox
				:items="location.items"
				:checkboxTitle="location.name"
				isOpenedInitially
				isParentCheckboxShown
			></NestedCheckbox>
		</template>

		<div class="typography-h5-str">{{ t('pcs_filter_specifications') }}</div>
		<NestedCheckbox
			:items="colorList"
			:checkboxTitle="t('pcs_filter_colours')"
		></NestedCheckbox>
		<NestedCheckbox
			:items="osList"
			:checkboxTitle="checkboxTitles[AttributeID.OS]"
		></NestedCheckbox>
		<NestedCheckbox
			:items="storageList"
			:checkboxTitle="checkboxTitles[AttributeID.STORAGE]"
		></NestedCheckbox>
		<NestedCheckbox
			:items="seriesList"
			:checkboxTitle="checkboxTitles[AttributeID.SERIES]"
		></NestedCheckbox>
		<NestedCheckbox
			:items="manufactList"
			:checkboxTitle="checkboxTitles[AttributeID.RAMSIZE]"
		></NestedCheckbox>
	</div>
</template>
